var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBus03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00781 10V5M11.0078 10V5M16.0078 10V5.5",
    stroke: "#C0C0C0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01999 17C3.60004 17 2.89006 17 2.44893 16.5607C2.00781 16.1213 2.00781 15.4142 2.00781 14V8C2.00781 6.58579 2.00781 5.87868 2.44893 5.43934C2.89006 5 3.60004 5 5.01999 5H12.1044C15.5781 5 17.3149 5 18.6441 5.70624C19.6229 6.22633 20.4385 7.0055 21.001 7.95786C21.7648 9.25111 21.8371 10.9794 21.9818 14.436C22.0207 15.3678 22.0402 15.8337 21.8581 16.1862C21.7243 16.4454 21.5174 16.6601 21.263 16.8041C20.9169 17 20.4488 17 19.5124 17H19.0078M9.00781 17H15.0078",
    stroke: "#C0C0C0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00781 19C8.11238 19 9.00781 18.1046 9.00781 17C9.00781 15.8954 8.11238 15 7.00781 15C5.90324 15 5.00781 15.8954 5.00781 17C5.00781 18.1046 5.90324 19 7.00781 19Z",
    stroke: "#C0C0C0",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19C18.1046 19 19 18.1046 19 17C19 15.8954 18.1046 15 17 15C15.8954 15 15 15.8954 15 17C15 18.1046 15.8954 19 17 19Z",
    stroke: "#C0C0C0",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99219 10.001H15.3602C15.9872 10.001 16.2002 10.3682 16.6802 10.9442C17.2322 11.4842 17.6054 11.8629 18.1202 11.9402C18.8402 12.0482 21.5042 11.9942 21.5042 11.9942",
    stroke: "#C0C0C0",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus03);
export default __webpack_public_path__ + "static/media/bus-03.bbc4877d45c51a5c5b0c0b1d88527154.svg";
export { ForwardRef as ReactComponent };